import React from 'react'

import { MenuItem, Tooltip, useDisclosure } from '@chakra-ui/react'
import { useDispatch, useSelector } from 'react-redux'

import {
  deselectConstituent,
  startExportConstituents,
} from '../../../../redux/features/constituentsSlice'
import { ExportLoading } from '../../../ui'
import { MergeConstituentModal } from '../merge'
import ConstituentExportLanguage from './ConstituentExportLanguage'

const ConstituentActionMenu = () => {
  const dispatch = useDispatch()
  const isExporting = useSelector(state => state.constituents.exporting)
  const selectedConstituents =
    useSelector(state => state.constituents.selected) || []

  const {
    isOpen: mergeIsOpen,
    onOpen: mergeOnOpen,
    onClose: mergeOnClose,
  } = useDisclosure()

  const {
    isOpen: exportIsOpen,
    onOpen: exportOnOpen,
    onClose: exportOnClose,
  } = useDisclosure()
  const minimumSelected = selectedConstituents.length >= 2

  return (
    <>
      <ConstituentExportLanguage
        isOpen={exportIsOpen}
        onClose={exportOnClose}
        onConfirm={() => {
          dispatch(startExportConstituents({ useFilters: true }))
          exportOnClose()
        }}
      />
      <MenuItem onClick={exportOnOpen}>Export current view</MenuItem>
      <Tooltip
        hasArrow
        label={
          !minimumSelected
            ? 'Must select at least two constituents to merge'
            : ''
        }
      >
        <MenuItem isDisabled={!minimumSelected} onClick={mergeOnOpen}>
          Merge selected constituents
          {minimumSelected && `(${selectedConstituents.length})`}
        </MenuItem>
      </Tooltip>
      {selectedConstituents.length > 0 && (
        <MenuItem
          onClick={() => {
            selectedConstituents.forEach(c => dispatch(deselectConstituent(c)))
          }}
        >
          Deselect all constituents
        </MenuItem>
      )}
      <ExportLoading isLoading={isExporting} />
      {mergeIsOpen && (
        <MergeConstituentModal isOpen={mergeIsOpen} onClose={mergeOnClose} />
      )}
    </>
  )
}

export default ConstituentActionMenu
